import AuthenticationContext from "../context/authenticationContext";
import { useContext } from "react";

/**
 * Hook to consume Authentication context
 */
const useAuthentication = () => {
  return useContext(AuthenticationContext);
};

export default useAuthentication;
